import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import courseImg from "../../assets/images/Digital-Marketing.jpg";
import webimg6 from "../../assets/images/webimg6.jpg";
import webimg2 from "../../assets/images/webimg2.jpg";
import { Link, useHistory } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import {
  Col,
  Row,
  CardBody,
  CardTitle,
} from "reactstrap";
import Marquee from "react-fast-marquee";
import "../../helpers/helper";




export default function OnsiteZoomCourses(props) {

  const [value, setValue] = React.useState(0)
  const [courses, setCourses] = useState(null);
  useEffect(() => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${global.config.Token}`;

    const getData = async () => {
      const res = await axios.get(global.config.URL.api.lms + 'my-onsite-courses');
      console.log(courses, 'invoices')
      setCourses(res.data.courses);
    }
    getData();

  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigateToZoom = (courseId) => {

    props.history.push({
      pathname: '/onsite-zoom-sessions',
      state: {
        course: courseId,
      }
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">

        <Breadcrumbs title="Dashboard" breadcrumbItem="Select Course To Get Zoom Session" />
        <Row>
          <Col lg={12}>
            <Card className="">
              <CardBody>
                <Marquee direction="left" speed={30}>
                  <CardTitle className="welcome">Click on the given below tab to join Live Zoom Class and after 2 or 3 days You will get Live Zoom Class Recording here in the Play Video button &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</CardTitle>
                </Marquee>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {

            courses ? courses.map((course, i) => (
              <Col md={4} sm={6} className="mt-3">
                <Card sx={{ maxWidth: 345 }} onClick={() => navigateToZoom(course.id)} >
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={global.config.URL.img.public + course.course.course_detail.img}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h6" className='heading' component="div">
                        {course.course.name}
                      </Typography>
                      <span className="badge rounded-pill bg-success">
                       Batch - {course.onsite_batch.number}
                      </span>
                      <Typography variant="body2" className='D
                              desc' align="justify" color="text.secondary">
                        {course.course.description}

                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>

                    <Button size="small" onClick={() => navigateToZoom(course.id)} className='btnn'>
                      <i className='fa fa-check'></i> &nbsp; Get Sessions
                    </Button>

                  </CardActions>
                </Card>
              </Col>
            ))

              :
              <>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave" variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave" variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave" variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
              </>
          }
        </Row>
      </div>
    </React.Fragment>
  );
}